<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="75px" height="75px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
    <image width="100" height="100" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
      AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACMVBMVEUAAAD/fwD/hQD/hwD/
      hgD/hQD/hgD/hQD/hgD/hQD/hgD/hQD/hgD/hQD/hQD/iwD/hQD/hQD/hQD/hQD/hgD/hwD/kQD/
      hwD/hQD/hgD/hgD/hAD/jAD/iwD/hgD/hQD/hQD/hgD/hwD/fwD/hgD/hQD/hgD/hgD/hQD/hQD/
      hQD/hAD/hwD/fwD/hwD/qgD/hQD/iAD/ggD/hgD/hQD/hgD/iAD/hgD/hQD/hQD/iAD/hgD/hQD/
      hgD/fwD/hQD/hgD/hQD/hgD/hQD/hQD/hQD/fwD/hQD/jQD/hgD/hgD/hgD/hAD/hQD/hQD/hgD/
      fwD//wD/hQD/hgD/hwD/hQD/hgD/hQD/hgD/hQD/hgD/hAD/gwD/hQD/hQD/hgD/hgD/iAD/hQD/
      hgD/hQD/hgD/hAD/hgD/hgD/hgD/iQD/hQD/hQD/hQD/hQD/hgD/hgD/igD/hQD/hgD/hQD/hQD/
      mQD/hQD/hgD/hQD/hQD/iAD/hgD/hQD/hgD/hwD/hQD/hgD/hQD/hQD/fwD/hQD/hgD/hAD/hgD/
      hQD/hgD/hQD/iAD/iQD/hQD/hgD/hQD/hgD/hgD/hgD/hgD/hQD/fwD/hgD/hQD/hQD/iAD/hQD/
      hQD/hgD/hAD/hgD/hQD/hQD/hQD/hQD/hgD/hwD/hQD/hQD/hQD/hgD/hgD/hgD/ggD/hQD/hQD/
      hQD/hgD/hgD/hQD/fwD/hgD/hQD/hgD/hgD/hgD/hgD///92Ja3pAAAAuXRSTlMACC5TcIujucfU
      4u7v4cYLVJHO/JBRB0+o861gFBaB6/ihMwqJ9s+vj29BMiISEQOxHifY3Y4c4Ow/KfWZOQI7kvA1
      9IQVDnMJh8QkGbB6qwQBpORk6U7Mg6KyNh89ntV9D0NyZ9dJyfn7GqzbeOdKeRj6ha6qBVqn2fIt
      8abaPkVGhiwMfMs07crCwzwNk5S9xeqpnJ0GbMgqK2vSzRu6abPWjdN34+VYWTeMJf4oUrjAlxCY
      0Pe0aMQkGOQAAAABYktHRLqjsUfaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH6QcZDToJ
      NgPRYQAABKxJREFUaN7tmOt/E0UUhqfQ0sY0va8ltJUK2oRL04qkl1QhtjYUGjBFSVMBoWDRIC3U
      S2qwKsjFomxJAAMIlFsFBEQRQfLfcc5emt1tdnd2kx9+cN8PzezMe87TnZ2ZPQkhlixZsmTJ0otR
      wYKFhUWLiktsL9ntpWlQqd3usJUVLyoqXLigIA+A8orKquq0hqqrapicQC/XLnamKeRcUldvEtHw
      ylIaAq/GV5eZQCx/7fW5DKVNLvcKZuWq1c0eTwshLR5P8+pVK5kVbldTaYbT+oZRxpo3hdC13oo2
      LWNbhbddsHZ0GmP4OriwrrfepjCvW+9/h7d3G2GUr8WYnnd7aQMCG+wY4egzANmIEZv6jfxfwc0Y
      s8XAjeDdvxcywiBkYCsEvU8f9AHYtwWMMQhpxuUYprYPgjtilEHIEIR9SGvejqfFDuOQnRhHu1k+
      AvMS4wxCdkHgbjrrcBd495iB7IXA9nVU1o/BOjJgBlLfCKH7qKyfgHOvGQYhi2kneg0YP20wB9kD
      sdH9FMYiMH5mjkEGDkDwqL4vNAa+gyYh5BCe2/qPPoyHQ4tZyPjnVCvTBa4vzDII+RLCv8o+FJv4
      On448477xjxkXybLZPzbiVhmpPOA7H09Znq24NU8Jkv13ffiwMFGeVFQY55BSI2iwBD2Zq+yKDmS
      C+SoItlSvljajTvoh2PHsY2PPW246pBqB2aoxNbxYxuj0D7BdZ+ca5FeXIHpH3OBdGOGKaGmPAHt
      U1wLi0ThKCjk7vAns+UgqP5nLsUEf7Ufy0uu1QOt0yzXbOLncWqa8XlCRvOHPD7mjJ3PkOB62NNY
      83DNMvpi1IySHGRC1leSyDVrokR2KczctLSvLjR6NhfEttFQnfR6WpzNo+fik0Lf4XL40hP2Jxz2
      aqPpq+3tCX8Y1lW5eEJNxs8dUT45rAHP57J8Rf0CiTZnH2rATbI+HxBcVNHxrENYa8ShgEhduNgj
      TkGPzXtJL+WvblvGX3I5BS/IeFqtTLgCI4dgA1UpprompoVI+RUP72qQf0FeyWpHxwxJKRigYg1K
      6to8+2CMzOCnKoSQC1nWjcbZP53Ffl3MpQq5CH9vzIh9bO1NfIg+1eeBc7UrzIrXMzfgukwX4uQm
      LaPhEei4pQZxI0P6JaMN9xoVRPYtjoGOWTUIlti10o4GKgh+N/FLuwN8WHbh3malHf409wbRgYzi
      x9CwOcjwEEb/pgthb+PnnbtzZb3mdNmk0zXw+x2Mvc3qQsj2KW4dbron/HP4q8F9NYgXBm8Kt30v
      yQV2dBN9CHnA/xjxRyszXhBg8CL6UA1yCZfwCBMoCP7Zym+SkQeEBkL6IopCzEtUVSl3Nkb6CB2E
      kH6XNPIvjWMlVix1uvrn51KFQOX6SAyMejUPyJg7KjofdWbPpQqBAiqSdHQ5Z+8/JDry3Zp1djmS
      kW71XBQDJvTfQ1iDyVTEakL+fpwPxuN/NCH51P8A8uRpPtI/faIJ0brWEnXsC4HgW07yO7NQEtCJ
      OlZeDLX9m+aKGzpRx16e/wSf0UKoY1NXlb5TMVoIfWxwUO47GaRlGImNXU86RZcz+Yz6PnKNtWTJ
      kiVLlmj0HNyPhTe1bdSBAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI1LTA3LTI1VDEzOjU4OjA5KzAw
      OjAwdJNzdQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNS0wNy0yNVQxMzo1ODowOSswMDowMAXOy8kA
      AAAASUVORK5CYII="
    />
  </svg>
</template>

<script>
export default {};
</script>
